'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var fingerprintCore = require('@bhkk/fingerprint-core');
var fingerprintjs = require('@fingerprintjs/fingerprintjs');
var _ = require('lodash');
var axios = require('axios');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var ___default = /*#__PURE__*/_interopDefaultLegacy(_);
var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);

function isOnServer() {
    return typeof window === 'undefined';
}
function setCookie(name, value, exdays, domain) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie = `${name} = ${value}; ${expires};path=\/; SameSite=Lax; domain=${domain}`;
}
function placeHolder() { }
/**
 * 获取cookie
 * @param {*} cname cookie的名称
 * @param {*} req ctx中的req
 */
function getCookie(cname, req) {
    let name = cname + "=";
    let decodedCookie;
    if (isOnServer()) {
        decodedCookie = decodeURIComponent(req.headers.cookie);
    }
    else {
        decodedCookie = decodeURIComponent(document.cookie);
    }
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return { target: c.substring(name.length, c.length), all: decodedCookie };
        }
    }
    return { target: "", all: "" };
}
/** 发送清楚指纹的请求 */
function xhrDeleteFingerprint(targetFingerprint) {
    const fingerprintApi = 'https://oauth.bihukankan.com/';
    const deleteFingerprint = "v2/session/uuid";
    const { target: ssoToken } = getCookie("ssoToken", null);
    axios__default["default"].request({
        url: fingerprintApi + deleteFingerprint,
        method: "delete",
        headers: {
            "Authorization": ssoToken,
            "Browser-Uuid": targetFingerprint
        }
    });
}

/** 开发环境 */
const isDev = process.env.NODE_ENV === "development";
/** 【功能】
 * 当新生成的指纹和旧指纹不一致时，请求后端清楚掉旧指纹。这能部分解决一个问题———用户重新
 * 登录之后会在已经登录的设备列表里面看到自己这个浏览器的信息，引起迷惑。
 * 【潜在风险】
 * 用户可以借由这个功能让任意一台设备下线。
 * 具体做法是用户在自己浏览器内将cookie-bhFingerprint设置成其他设备(目标设备)的指纹，
 * 然后触发页面上的ajax请求，
 * 这一操作会让本函数被执行，引发目标设备的指纹失效，最终导致目标设备需要重新登录才能继续使用。
 * 只不过这一操作的前提是目标设备的指纹信息已经暴露。
 * 暂时想象不到这有什么现实意义上的风险，然而收益却是实打实的。
 */
function clearInvalidFingerprint(newFingerprint) {
    const { target: oldFingerprint } = getCookie('bhFingerprint', null);
    if (oldFingerprint !== newFingerprint) {
        //如果新旧指纹不相等就得发请求
        xhrDeleteFingerprint(oldFingerprint);
    }
}
async function collectFingerprintsProduction() {
    const browserMark = fingerprintCore.getMarkFromCookie();
    const visitorId = await fingerprintCore.doCollectFingerprintsProduction();
    const isBHKK = window.location.hostname.indexOf(".bihukankan.com") >= 0;
    const domain = isBHKK ? ".bihukankan.com" : window.location.hostname;
    const newFingerprint = fingerprintjs.murmurX64Hash128(browserMark + visitorId);
    clearInvalidFingerprint(newFingerprint);
    setCookie("bhFingerprint", newFingerprint, 365, domain);
}
async function createUuidGenerator(env) {
    const _isDev = env ? env === "development" : isDev;
    if (_isDev || isOnServer())
        return placeHolder;
    else {
        return await ___default["default"].throttle(() => collectFingerprintsProduction(), 2000);
    }
}

exports.createUuidGenerator = createUuidGenerator;
